// extracted by mini-css-extract-plugin
export default {"modalCTAWrapper":"EditUserControl_modalCTAWrapper__k4IL9"};